import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { scrollToPurchase } from '../utils/scrollToPurchase';
export function FinalCTA() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center border-t border-zinc-900" data-id="element-69">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-70">
        <h2 className="text-4xl md:text-5xl font-heading font-black text-white mb-6 uppercase leading-tight" data-id="element-71">
          De Martes Vacío a{' '}
          <span className="text-amber-500" data-id="element-72">Semana Completa.</span>
        </h2>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-12 text-xl font-bold text-zinc-300 uppercase tracking-wide" data-id="element-73">
          <span data-id="element-74">Más Plata.</span>
          <span className="hidden md:block text-amber-500" data-id="element-75">•</span>
          <span data-id="element-76">Menos Finde Reventado.</span>
          <span className="hidden md:block text-amber-500" data-id="element-77">•</span>
          <span data-id="element-78">Más Control.</span>
        </div>

        <div className="max-w-md mx-auto" data-id="element-79">
          <Button size="xl" fullWidth onClick={scrollToPurchase} data-id="element-80">
            ACCEDER AHORA
          </Button>
        </div>
      </motion.div>
    </section>;
}